module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-link"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Products in this bundle")]), _vm._v(" "), _c('div', [(_vm.bundledProducts.length < 1) ? _c('div', [_vm._v("\n            This bundle does not have any products\n            "), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bundledProducts), function(product) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'product',
          params: {
            id: product.id
          }
        }
      }
    }, [_vm._v("\n                " + _vm._s(product.short_name) + "\n            ")]), _vm._v(" "), _c('a', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.remove(product)
        }
      }
    })], 1)
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.adding) ? _c('div', [_c('a', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        _vm.adding = true
      }
    }
  }, [_vm._v("Add product to bundle...")])]) : _vm._e(), _vm._v(" "), (_vm.adding) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    attrs: {
      "name": "product-add"
    },
    on: {
      "change": function($event) {
        return _vm.add($event.target.value)
      }
    }
  }, [_c('option', [_vm._v("Select a product...")]), _vm._v(" "), _vm._l((_vm.availableProducts), function(product) {
    return _c('option', {
      domProps: {
        "value": product.id
      }
    }, [_vm._v(_vm._s(product.short_name) + " - " + _vm._s(product.sku))])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.adding = false
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5af4558c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/products/BundleProducts.vue
// module id = 539
// module chunks = 0